import CreateTouristPromotion from './CreateTouristPromotion.container';

export default CreateTouristPromotion;
